import Loading from './Loading';

import { LoadingProps } from './Loading.types';

export type { LoadingProps };

export default Loading;
